
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { 
  FiLock, 
} from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { editClient } from '../api/clientApi';
import { toast } from 'react-toastify';

export default function UpdatePassword() {
       const { clientData,setclientData } = useAuth();
      const [activeTab, setActiveTab] = useState('profile');
      const { register, handleSubmit,watch, formState: { errors } } = useForm();

        const onSubmit =async (data) => {
          try{
          const payload={...data, client_id: clientData?.client_id};
         const result= await editClient(payload);
         console.log(result)
         setclientData(result);
         toast.success('Update password Success');
        } catch (error) {
            console.error(error);
            toast.error('Update password Failed: ',error);
          }
        };
  return (
           <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <FiLock className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="password"
        placeholder="Enter new password"
        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        {...register('password', { required: 'New password is required' })}
      />
    </div>
    {errors.password && (
      <p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
    )}
  </div>

  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <FiLock className="h-5 w-5 text-gray-400" />
      </div>
      <input
        type="password"
        placeholder="Confirm new password"
        className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        {...register('confirm_password', {
          required: 'Please confirm your password',
          validate: value =>
            value === watch('password') || 'Passwords do not match',
        })}
      />
    </div>
    {errors.confirm_password && (
      <p className="text-red-500 text-sm mt-1">{errors.confirm_password.message}</p>
    )}
  </div>

  <button
    type="submit"
    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
  >
    Update Password
  </button>
</form>
          )
}
